import { IntlFormatters } from 'react-intl'

export const BMI_ADDITIONAL_QUESTIONS_BY_NAME = (
  f: IntlFormatters['formatMessage'],
) => ({
  question1: {
    id: 1,
    value: f({
      id: 'bmi.question.weightLossSupport',
      defaultMessage: 'Are you interested in weight-loss treatment/support?',
    }),
  },
  question2: {
    id: 2,
    value: f({
      id: 'bmi.question.glp1Awareness',
      defaultMessage: 'Are you aware of GLP-1 treatment?',
    }),
  },
  newsletter: {
    id: 3,
    value: f({
      id: 'bmi.newsletter.label',
      defaultMessage:
        'Stay in the loop, shed the weight: Get expert updates on weight loss treatments and support directly to your inbox',
    }),
  },
})
